import daniel from "../../../img/daniel.png";
import itay from "../../../img/itay.png"
import igor from "../../../img/igor.png"
import or from "../../../img/or.png"
import aron from "../../../img/aron.png"

const recommendationList = [
    {
        img: daniel,
        name: "Daniel Galle",
        position: "Co-founder, Nolah Mattresses",
        recommendation: "We use Fixel primarily for our retargeting and user segmentation. Our Fixel retargeting audiences perform at +10x ROAS"
    },
    {
        img: itay,
        name: "Itay Waisman",
        position: "Online Marketing Manager, Appsflyer",
        recommendation: "Using Fixel we cut our lead cost by 50%"
    },
    {
        img: igor,
        name: "Igor Zvagelsky",
        position: "CEO, ROI Escalator",
        recommendation: "Fixel automates my work, allowing me to focus on what’s important"
    },
    {
        img: or,
        name: "Or Cohen",
        position: "VP E-Commerce, Ortal Digital",
        recommendation: "Fixel has enabled us to identify and target with surgical accuracy, highly engaged audiences that we were unable to effectively reach in the past"
    },
    {
        img: aron,
        name: "Aron Skversky",
        position: "Director of Acquisition, Lawgeex",
        recommendation: "With Fixel, remarketing became a viable, lucrative option for us"
    },
]

export const getRecommendee = () => {
    const length  = recommendationList.length;
    return recommendationList[Math.floor(length * Math.random())];
}



export default recommendationList